module.exports = __webpack_public_path__ + "img/stavropol-places.1e893c6b.jpeg";